<template>
  <div class="container has-text-centered">
    <h4 class="title is-4">Devices Locations</h4>
    <div class="container has-text-left">
      <div class="block">
        <b-field label="Device" label-position="on-border">
          <b-select placeholder="Select a device..." v-model="deviceName">
            <option v-for="rd in roamingDevices"
                    :value="rd.name"
                    :key="rd.name"
            >{{rd.name}}
            </option>
          </b-select>
        </b-field>

        <b-field label="Date" label-position="on-border">
          <b-datepicker v-model="dateStart"
                        @icon-right-click="clearDate"
                        trap-focus
          ></b-datepicker>
        </b-field>

        <b-button type="is-success" :disabled="!areFiltersOk()" @click="handleClickShow">Show</b-button>
      </div>
    </div>

    <div class="container has-text-centered map_holder">
      <div class="map" id="map"></div>
    </div>

    <div class="container has-text-left locations_list">
      <div class="block">Distance: {{totalDistance}} km</div>

      <b-table v-if="tableData.length > 0"
               :narrowed="true"
               :striped="true"
               :data="tableData"
      >
        <template slot-scope="props">
          <b-table-column field="num" numeric class="is-hidden-mobile">{{props.row.num}}</b-table-column>
          <b-table-column field="time" centered label="Time">{{props.row.time}}</b-table-column>
          <b-table-column field="location" centered label="Location">{{props.row.location}}</b-table-column>
        </template>
      </b-table>
    </div>
  </div>
</template>

<script>
  /* eslint-disable no-undef */

  import {mapGetters, mapActions, mapMutations} from 'vuex';
  import {formatTime} from "../utils/utils";
  import BField from "buefy/src/components/field/Field";
  import BSelect from "buefy/src/components/select/Select";
  import BDatepicker from "buefy/src/components/datepicker/Datepicker";
  import BButton from "buefy/src/components/button/Button";
  import BTable from "buefy/src/components/table/Table";
  import BTableColumn from "buefy/src/components/table/TableColumn";

  export default {
    components: {
      BTableColumn,
      BTable,
      BButton,
      BDatepicker,
      BSelect,
      BField
    },
    name: "screendeviceslocations",
    data() {
      return {
        deviceName: null,
        dateStart: new Date(),
        dateStop: new Date(),
        gmap: null,
        markers: [],
        path: null
      };
    },
    computed: {
      ...mapGetters('devices', ['roamingDevices']),
      ...mapGetters('integrations', ['queryLocationResponse']),
      ...mapGetters('ui', ['googleMapsBaseUrl', 'googleMapsApiKey', 'googleMapsLibLoaded']),
      googleMapsLibUrl() {
        return `${this.googleMapsBaseUrl}?key=${this.googleMapsApiKey}&callback=initMap`;
      },
      tableData() {
        const ret = [];

        if (this.queryLocationResponse) {
          const { data: { positions } } = this.queryLocationResponse;

          let num = 0;
          positions.forEach(item => {
            num += 1;
            const obj = {
              ...item,
              num,
              location: item.region_name ? item.region_name : `${item.lat}, ${item.lng}`
            };

            ret.push(obj);
          });
        }

        return ret;
      },
      totalDistance() {
        return this.queryLocationResponse && this.queryLocationResponse.data ? this.queryLocationResponse.data.distance : 0;
      }
    },
    methods: {
      ...mapActions('integrations', ['queryLocation']),
      ...mapMutations('ui', ['SET_GOOGLE_MAPS_LIB_LOADED']),
      clearDate() {
        this.dateStart = null;
        this.dateStop = null;
      },
      clearMarkers() {
        if (this.gmap) {
          this.markers.forEach(item => {
            item.setMap(null);
          });

          this.path.setMap(null);

          this.markers = [];
          this.path = null;
        }
      },
      areFiltersOk() {
        return this.deviceName !== null && this.dateStart !== null;
      },
      handleClickShow() {
        const timestampDateStart = Math.floor(this.dateStart.getTime() / 1000);

        const payload = {
          name: 'path',
          filters: {
            deviceName: this.deviceName,
            date: formatTime(timestampDateStart, 'YYYY-MM-DD')
          }
        };
        this.clearMarkers();
        this.queryLocation({
          payload,
          success: () => {
            this.loadGoogleMapsLib();
          }
        });
      },
      loadGoogleMapsLib() {
        if (!this.googleMapsLibLoaded) {
          const script = document.createElement('script');
          script.setAttribute('src', this.googleMapsLibUrl);
          script.setAttribute('async', 'async');
          document.body.appendChild(script);
          this['SET_GOOGLE_MAPS_LIB_LOADED']();
        } else {
          this.initMap();
        }
      },
      prepareMarker(props) {
        const { index, firstIndex, lastIndex, lat, lng, time, title } = props;
        let markerIcon = null;
        if (firstIndex) {
          markerIcon = {
            path: "M10.453 14.016l6.563-6.609-1.406-1.406-5.156 5.203-2.063-2.109-1.406 1.406zM12 2.016q2.906 0 4.945 2.039t2.039 4.945q0 1.453-0.727 3.328t-1.758 3.516-2.039 3.070-1.711 2.273l-0.75 0.797q-0.281-0.328-0.75-0.867t-1.688-2.156-2.133-3.141-1.664-3.445-0.75-3.375q0-2.906 2.039-4.945t4.945-2.039z",
            fillColor: "blue",
            fillOpacity: 0.6,
            strokeWeight: 0,
            rotation: 0,
            scale: 2,
            anchor: new google.maps.Point(15, 30),
          };
        } else if (lastIndex) {
          markerIcon = {
            path: "M10.453 14.016l6.563-6.609-1.406-1.406-5.156 5.203-2.063-2.109-1.406 1.406zM12 2.016q2.906 0 4.945 2.039t2.039 4.945q0 1.453-0.727 3.328t-1.758 3.516-2.039 3.070-1.711 2.273l-0.75 0.797q-0.281-0.328-0.75-0.867t-1.688-2.156-2.133-3.141-1.664-3.445-0.75-3.375q0-2.906 2.039-4.945t4.945-2.039z",
            fillColor: "green",
            fillOpacity: 0.6,
            strokeWeight: 0,
            rotation: 0,
            scale: 2,
            anchor: new google.maps.Point(15, 30),
          };
        }

        const markerOptions = {
          position: {
            lat,
            lng
          },
          title
        };
        if (markerIcon) {
          markerOptions['icon'] = markerIcon;
        }
        const marker = new google.maps.Marker(markerOptions);
        marker.addListener('click', () => {
          const content = `<div style="color: #000; text-align: left;"><h4>#${index} - ${time}</h4><div>Lat: ${lat}<br />Lng: ${lng}</div></div>`;
          const infoWindow = new google.maps.InfoWindow({
            content
          });
          infoWindow.open({
            anchor: marker,
            map: this.gmap,
            shouldFocus: false
          })
        });

        return marker;
      },
      initMap() {
        const center = { lat: 47, lng: 28 };

        if (!this.gmap) {
          this.gmap = new google.maps.Map(document.getElementById('map'), {
            zoom: 6,
            center,
          });
        }

        if (this.queryLocationResponse) {
          const { data: { positions } } = this.queryLocationResponse;

          const mapBounds = new google.maps.LatLngBounds();

          let index = 0;
          const count = positions.length;
          const pathPoints = [];
          positions.forEach(item => {
            const displayedIndex = index + 1;
            const title = `#${displayedIndex} - ${item.time}`;
            const enrichedItem = {
              ...item,
              index,
              title,
              firstIndex: index === 0,
              lastIndex: index === count - 1
            };

            index += 1;

            const marker = this.prepareMarker(enrichedItem);

            this.markers.push(marker);
            pathPoints.push({ lat: item.lat, lng: item.lng });
            mapBounds.extend(new google.maps.LatLng(item.lat, item.lng));
          });

          this.markers.forEach(item => {
            item.setMap(this.gmap);
          });

          this.path = new google.maps.Polyline({
            path: pathPoints,
            geodesic: true,
            strokeColor: "#FF0000",
            strokeOpacity: 1.0,
            strokeWeight: 2,
          });

          this.path.setMap(this.gmap);

          this.gmap.fitBounds(mapBounds);
        }
      }
    },
    mounted() {
      window.initMap = this.initMap;
      this.clearMarkers();
    },
    unmounted() {
      this.clearMarkers();
      this.gmap = null;
    }
  }
</script>

<style scoped>
  .map {
    height: 400px;
    width: 95%;
  }

  .map_holder {
    margin-top: 0.5rem;
  }

  .locations_list {
    margin-top: 1rem;
    margin-bottom: 2.5rem;
  }
</style>